import { createIcon } from '../icon'
import NavigationBackIcon from '../svg/NavigationBackIcon'

export const NavigationBackIconDefault = createIcon(NavigationBackIcon)
